import React from 'react';
import { Button, refreshPreloadedAssets } from '@meu-mapa-nev/design-system';
import { AlertComFoco } from './AlertComFoco.js';
/** Falhas de carregamento de uma área preservam a navegação da administração. */
export class PanelBoundary extends React.Component<
  React.PropsWithChildren,
  { failed: boolean; refreshing: boolean }
> {
  override state = { failed: false, refreshing: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  override render() {
    return this.state.failed ? (
      <section>
        <AlertComFoco type="critical">
          Esta área não pôde ser carregada. Verifique a conexão e atualize a página.
        </AlertComFoco>
        <Button
          type="button"
          disabled={this.state.refreshing}
          aria-busy={this.state.refreshing}
          onClick={() => {
            this.setState({ refreshing: true });
            void refreshPreloadedAssets().finally(() => window.location.reload());
          }}
        >
          {this.state.refreshing ? 'Atualizando…' : 'Atualizar página'}
        </Button>
      </section>
    ) : (
      this.props.children
    );
  }
}
